/* LayLax 販促素材ポータル（商品メタフィールド方式）
 * 作成日: 2026-08-05
 *
 * 役割は2つだけ。
 *   1. このページ内のキーワード絞り込み（ブランド・発売年はShopify標準フィルタが担当）
 *   2. ダウンロードのGA4計測
 * 依存なし。
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-promo-root]');
  if (!root) return;

  var grid    = root.querySelector('[data-promo-grid]');
  var qInput  = root.querySelector('[data-promo-q]');
  var newOnly = root.querySelector('[data-promo-new]');
  var emptyEl = root.querySelector('[data-promo-empty]');
  if (!grid) return;

  /* ---------- ページ内絞り込み（キーワード＋新着） ---------- */
  // どちらもこのページ内だけに効く。ブランド等の標準フィルタは
  // サーバー側で全ページに効くので、そちらとは別物として扱う。
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.promo-card'));

  var filter = function () {
    var q = qInput ? (qInput.value || '').trim().toLowerCase() : '';
    var onlyNew = !!(newOnly && newOnly.checked);
    var shown = 0;

    cards.forEach(function (card) {
      var hay = (card.dataset.search || '').toLowerCase();
      var hit = (!q || hay.indexOf(q) !== -1) &&
                (!onlyNew || card.dataset.new === '1');
      card.hidden = !hit;
      if (hit) shown++;
    });

    if (emptyEl) emptyEl.hidden = shown !== 0;
  };

  if (qInput) {
    var timer;
    qInput.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(filter, 150);
    });

    // Enterでフォーム送信されると標準フィルタが飛ぶので抑止する
    qInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); filter(); }
    });
  }

  if (newOnly) {
    newOnly.addEventListener('change', filter);
    // チェックしたままページを移っても意図が残るよう、URLからも受ける
    if (/[?&]new=1/.test(window.location.search)) {
      newOnly.checked = true;
      filter();
    }
  }

  /* ---------- タブ ---------- */
  // 商品素材とブランド素材の出し分け。#assets 付きのURLで直接開ける。
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
  if (tabs.length) {
    var show = function (name) {
      tabs.forEach(function (b) {
        var on = b.dataset.tab === name;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-pane]').forEach(function (pane) {
        pane.hidden = pane.dataset.pane !== name;
      });
    };
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        show(b.dataset.tab);
        history.replaceState(null, '',
          b.dataset.tab === 'assets' ? '#assets' : location.pathname + location.search);
      });
    });
    if (location.hash === '#assets') show('assets');
  }

  /* ---------- URLコピー ---------- */
  // ZIPのダウンロードURLをクリップボードへ。メールに貼って販売店へ渡す用途。
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // http のプレビュー環境などクリップボードAPIが使えない場合の代替
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      ok ? resolve() : reject(new Error('コピーできませんでした'));
    });
  }

  // 商品グリッドとブランド素材グリッドの両方で効くよう、根元で受ける
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.promo-card__copy');
    if (!btn) return;
    e.preventDefault();

    var url = btn.dataset.copy;

    // アイコンの出し分けは CSS（.is-done）で行う。
    // textContent を書き換えると中の svg が消えるので触らない。
    copyText(url).then(function () {
      btn.classList.add('is-done');
      btn.setAttribute('title', 'コピーしました');
      setTimeout(function () {
        btn.classList.remove('is-done');
        btn.setAttribute('title', 'ダウンロードURLをコピー');
      }, 1600);
    }).catch(function () {
      window.prompt('下のURLをコピーしてください', url);
    });
  });

  /* ---------- ダウンロード計測 ---------- */
  root.addEventListener('click', function (e) {
    var link = e.target.closest('.promo-card__dl, .promo-card__sub');
    if (!link) return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'promo_download', {
      asset_kind:  link.dataset.video ? 'video' : 'zip',
      product_sku: link.dataset.sku   || '',
      product_name: link.dataset.title || '',
      brand:       link.dataset.brand || ''
    });
  });
})();
